// src/api/pricingService.ts
import apiClient from './config';

export const getTokenPrice = async (
  numTokens: number,
  currency: string
) => {
  const { data } = await apiClient.get("/pricing/tokens", {
    params: { num_tokens: numTokens, currency: currency.toUpperCase() }
  });
  return data as { price:number; currency:string };
};
